export function normalizeNumericText(value, { decimalPlaces = 6, allowNegative = false, phone = false } = {}) {
    let text = String(value ?? '').replace(/\u2212/g, '-');
    if (phone) return /^\+?[0-9 ()-]*$/.test(text) ? text : null;
    text = text.replace(/,/g, '.');
    const sign = allowNegative ? '-?' : '';
    const pattern = decimalPlaces === 0
        ? new RegExp(`^${sign}\\d*$`)
        : new RegExp(`^${sign}\\d*(?:\\.\\d{0,${decimalPlaces}})?$`);
    if (!pattern.test(text)) return null;
    if (text.startsWith('.')) text = '0' + text;
    if (text.startsWith('-.')) text = '-0' + text.slice(1);
    return text;
}

export function sameNumericValue(text, value) {
    const external = String(value ?? '');
    if (text === external) return true;
    return text !== '' && text !== '-' && external !== ''
        && Number.isFinite(Number(text)) && Number(text) === Number(external);
}

export function numericValidity(text, { min, max, phone = false } = {}) {
    if (!text || phone) return '';
    if (!Number.isFinite(Number(text))) return 'Введи число.';
    if (min != null && min !== '' && Number(text) < Number(min)) return `Минимальное значение: ${min}.`;
    if (max != null && max !== '' && Number(text) > Number(max)) return `Максимальное значение: ${max}.`;
    return '';
}